import { createFileRoute } from "@tanstack/react-router";

import { faqJsonLd } from "../components/tools/tool-layout";
import { SA_COPY, SaCalculatorView } from "../components/tools/weeks";
import { seo } from "../lib/head";

export const Route = createFileRoute("/calcul-semaines-amenorrhee")({
  staticData: { ssr: true },
  head: () =>
    seo({
      title: "Calcul des semaines d'aménorrhée (SA) en ligne · Listou",
      description:
        "À combien de SA êtes-vous ? Semaines d'aménorrhée, semaines de grossesse, mois et trimestre en cours, avec la taille de bébé cette semaine.",
      jsonLd: faqJsonLd(SA_COPY.faq),
    }),
  component: SaCalculatorView,
});
